import { orderItem } from './orderQueries';

export const updateAnOrder = /* GraphQL */ `
  mutation UpdateAnOrder($input: OrderInput!) {
    updateAnOrder(input: $input) ${orderItem}
  }
`;
